import React, { useState } from 'react';
import { HiMail, HiLocationMarker } from 'react-icons/hi';
import { useLanguage } from '../../i18n/LanguageContext';
import './Contact.css';

const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__container">
        <div className="contact__header">
          <span className="contact__eyebrow">{t('contact.eyebrow')}</span>
          <h2 className="contact__title">{t('contact.title')}</h2>
          <p className="contact__subtitle">
            {t('contact.subtitle')}
          </p>
        </div>

        <div className="contact__content">
          <div className="contact__info">
            <div className="contact__info-card">
              <div className="contact__info-icon"><HiLocationMarker /></div>
              <div>
                <h4>{t('contact.headquartersLabel')}</h4>
                <p>{t('contact.headquartersValue')}</p>
              </div>
            </div>

            <div className="contact__info-card">
              <div className="contact__info-icon"><HiMail /></div>
              <div>
                <h4>{t('contact.emailLabel')}</h4>
                <p>contact@mai.ma</p>
              </div>
            </div>

            <div className="contact__map-placeholder">
              <div className="contact__map-dot"></div>
              <span>{t('contact.mapLabel')}</span>
            </div>

            <div className="contact__next">
              <h4>{t('contact.nextTitle')}</h4>
              <ul className="contact__next-list">
                {t('contact.nextItems').map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <form className="contact__form" onSubmit={handleSubmit}>
            <div className="contact__form-row">
              <div className="contact__form-group">
                <label htmlFor="name">{t('contact.form.nameLabel')}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder={t('contact.form.namePlaceholder')}
                  required
                />
              </div>
              <div className="contact__form-group">
                <label htmlFor="email">{t('contact.form.emailLabel')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={t('contact.form.emailPlaceholder')}
                  required
                />
              </div>
            </div>

            <div className="contact__form-group">
              <label htmlFor="company">{t('contact.form.companyLabel')}</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder={t('contact.form.companyPlaceholder')}
              />
            </div>

            <div className="contact__form-group">
              <label htmlFor="message">{t('contact.form.messageLabel')}</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder={t('contact.form.messagePlaceholder')}
                rows="5"
                required
              />
            </div>

            <button type="submit" className="contact__submit-btn">
              {t('contact.form.submitLabel')}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
